import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SellMyVehicle from "../views/SellMyVehicle.vue";
import BuyMyVehicle from "../views/BuyMyVehicle.vue";
import ShopKeeper from "../views/ShopKeeper.vue";
import About from "../views/About.vue";
import HowItWorks from "../views/HowItWorks.vue";
import Services from "../views/Services.vue";
import CommomQuestions from "../views/CommomQuestions.vue";
import Contact from "../views/Contact.vue";
import Erro404 from "../views/404.vue";
import Thanks from "../views/Thanks.vue";
import ThanksTrader from "../views/ThanksTrader.vue";
import TraderRoute from "../views/TraderRoute.vue";
import WhatsApp from "../views/WhatsApp";

Vue.use(VueRouter);

const routes = [
  // register routes
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/vender-meu-carro",
    name: "vender-meu-carro",
    component: SellMyVehicle,
  },
  {
    path: "/sou-lojista",
    name: "sou-lojista",
    component: ShopKeeper,
  },
  {
    path: "/comprar-meu-carro",
    name: "comprar-meu-carro",
    component: BuyMyVehicle,
  },
  {
    path: "/quem-somos",
    name: "about",
    component: About,
  },
  {
    path: "/como-funciona",
    name: "how-it-works",
    component: HowItWorks,
  },
  {
    path: "/seja-um-franqueado",
    name: "services",
    component: Services,
  },
  {
    path: "/perguntas-frequentes",
    name: "commom-questions",
    component: CommomQuestions,
  },
  {
    path: "/contato",
    name: "contact",
    component: Contact,
  },
  {
    path: "/obrigado",
    name: "obrigado",
    component: Thanks,
  },
  {
    path: "/obrigado-trader",
    name: "obrigado-trader",
    component: ThanksTrader,
  },
  {
    path: "/contato-whatsapp",
    name: "whatsapp",
    component: WhatsApp,
  },
  {
    path: "/rota-do-trader",
    name: "trader-route",
    component: TraderRoute,
  },

  // 404
  {
    path: "*",
    name: "404",
    component: Erro404,
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: function(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes,
});

export default router;
